import React, { Component } from "react";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import MatchesTable from "./matchesTable";
import { getMatches, deleteMatch } from "./../../services/matchService";
import "react-confirm-alert/src/react-confirm-alert.css";
import _ from "lodash";

class Matches extends Component {
  state = { matches: [], sortColumn: { key: "name", order: "asc" } };

  async componentDidMount() {
    const matches = await getMatches();
    this.setState({ matches });
  }

  handleDelete = async match => {
    confirmAlert({
      title: "Delete Match",
      message: "Are you sure you want to delete '" + match.name + "'?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            const matches = this.state.matches.filter(s => s.id !== match.id);
            this.setState({ matches });

            await deleteMatch(match.id);
          }
        },
        {
          label: "No",
          onClick: () => {}
        }
      ]
    });
  };

  handleSort = sortColumn => {
    this.setState({ sortColumn });
  };

  getSortedData = () => {
    const { matches, sortColumn } = this.state;
    const sorted = _.orderBy(matches, [sortColumn.key], [sortColumn.order]);
    return { matches: sorted };
  };

  render() {
    const { sortColumn } = this.state;
    const { matches } = this.getSortedData();

    return (
      <div>
        <h2>Matches</h2>
        <Link
          to="/matches/new"
          className="btn btn-primary"
          style={{ marginBottom: 20 }}
        >
          <i className="fa fa-file" />
        </Link>
        <MatchesTable
          matches={matches}
          sortColumn={sortColumn}
          onEdit={this.handleEdit}
          onDelete={this.handleDelete}
          onSort={this.handleSort}
        />
      </div>
    );
  }
}

export default Matches;



// WEBPACK FOOTER //
// ./src/components/matches/matches.jsx